export const calculatePercentageDifference = (
  originalValue: number,
  newValue: number
) => {
  let difference = newValue - originalValue;
  let percentageDifference = (difference / Math.abs(originalValue)) * 100;

  return percentageDifference;
};
